import React, { useContext } from 'react'
import { LockOutlined, LogoutOutlined } from '@ant-design/icons';

import "./NavbarAdmin.css"
import { Button } from 'antd';
import { adminRoutes } from '../Routes/Routes';
import { Route } from '../Models/Route';
import { useNavigate } from 'react-router-dom';
import { PromiseSesionContext } from '../Machines/ErrorMachine';
import NavbarAdminItem from './NavbarAdminItem';

const NavbarAdmin = () => {
    const [routes, setRoutes] = React.useState<Route[]>(adminRoutes);
    const navigate = useNavigate();
    const {sesion, sendSesion} = useContext(PromiseSesionContext);

    
    const closeSession = () => {
        localStorage.removeItem("token")
        sendSesion("UNAUTHORIZED");
        navigate("/loginadmin");

    }

    const goToLogin = () => {
        navigate("/ingresar");

    }
  return (
    <>
    <div className='navbarAdmin-section-desk'>
        <div className='navbarAdmin-section-desk-header'>
            <div className='navbarAdmin-section-desk-headerLogo'>
                <img src='/logo.png' alt='Logo frikistore' />
            </div>
        </div>

        <div className='navbarAdmin-section-desk-body'>
            {routes.map((route:Route)=>{
                if(!route.navbarShow) return null
                return <NavbarAdminItem route={route} />
            })}
        </div>

        <div className='navbarAdmin-section-desk-footer'>
            <Button type='primary' shape='round' onClick={() =>{closeSession()}} ><LogoutOutlined /> Cerrar Sesión</Button>

        </div>

    </div>
    </>
  )
}

export default NavbarAdmin